import { createContext } from 'react'

import type { FeatureFlagsContext as FeatureFlagsContextValue } from '../types'

export const FeatureFlagsContext = createContext<FeatureFlagsContextValue>({})

/** @alias */
export default FeatureFlagsContext
